import React, { useState } from "react";
import {
  FaAlignCenter,
  FaHome,
  FaUser,
  FaCalendar,
  FaTable,
  FaMapMarkedAlt,
  FaCalendarDay,
} from "react-icons/fa";
import { Image } from "react-bootstrap";
import { GiHumanPyramid } from "react-icons/gi";
import { Link } from "react-router-dom";
import Logo from "../../gif/logo.png";
import { RiBarChartHorizontalLine } from "react-icons/ri";
import { FaSms } from "react-icons/fa";

function SideBar() {
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [isMemberMenuOpen, setIsMemberMenuOpen] = useState(false);

  const toggleSidebar = () => {
    setIsCollapsed(!isCollapsed);
  };

  const toggleMemberMenu = () => {
    setIsMemberMenuOpen(!isMemberMenuOpen);
  };

  return (
    <div className="d-flex">
      <div
        className={`text-white d-flex flex-column position-sticky ${
          isCollapsed ? "sidebar-collapsed" : ""
        }`}
        style={{
          width: isCollapsed ? "80px" : "250px",
          height: "100vh",
          justifyContent: "space-between",
          backgroundColor: "#383a4e",
          top: 0,
          left: 0,
          bottom: 0,
          overflowY: "auto",
          transition: "width 0.3s",
        }}
      >
        <div className="pl-5">
          <div className="p-3 text-center">
            {isCollapsed ? (
              <h5>NTC</h5>
            ) : (
              <div className="row text-center">
                <Image
                  src={Logo}
                  roundedCircle
                  alt="Profile"
                  style={{ width: "120px", height: "100px", marginLeft: "25%" }}
                />
              </div>
            )}
            <div className="row text-center">
              <button className="btn" onClick={toggleSidebar}>
                <FaAlignCenter className="me-2 text-white" size={25} />
              </button>
            </div>
          </div>

          <ul className="nav flex-column p-3">
            <small className="nav mb-2 text-secondary">Main</small>

            {/* Updated Links without anchor tags */}
            <Link
              to="/"
              className="nav-item mb-2 border-start border-secondary"
              style={{ textDecoration: "none" }}
            >
              <span className="nav-link text-white">
                <FaHome className="me-2" /> {!isCollapsed && "Dashboard"}
              </span>
            </Link>

            <Link
              to="/attandance"
              className="nav-item mb-2 border-start border-secondary"
              style={{ textDecoration: "none", backgroundColor: "#383a4e" }}
            >
              <span className="nav-link text-white">
                <RiBarChartHorizontalLine className="me-2" />{" "}
                {!isCollapsed && "Attandance"}
              </span>
            </Link>

            <Link
              to="/bulksms"
              className="nav-item mb-2 border-start border-secondary"
              style={{ textDecoration: "none", backgroundColor: "#383a4e" }}
            >
              <span className="nav-link text-white">
                <RiBarChartHorizontalLine className="me-2" />{" "}
                {!isCollapsed && "Insights / Stats"}
              </span>
            </Link>

            <Link
              to="/members"
              className="nav-item mb-2 border-start border-secondary"
              style={{ textDecoration: "none" }}
            >
              <span className="nav-link text-white">
                <FaUser className="me-2" /> {!isCollapsed && "Members"}
              </span>
            </Link>

            <Link
              to="/calendar"
              className="nav-item mb-2 border-start border-secondary"
              style={{ textDecoration: "none" }}
            >
              <span className="nav-link text-white">
                <FaCalendar className="me-2" /> {!isCollapsed && "Calendar"}
              </span>
            </Link>
            <Link
              to="/chat"
              className="nav-item mb-2 border-start border-secondary"
              style={{ textDecoration: "none" }}
            >
              <span className="nav-link text-white">
                <FaSms className="me-2" /> {!isCollapsed && "Messages"}
              </span>
            </Link>

            <Link
              to="/events"
              className="nav-item mb-2 border-start border-secondary"
              style={{ textDecoration: "none" }}
            >
              <span className="nav-link text-white">
                <FaCalendarDay className="me-2" /> {!isCollapsed && "Events"}
              </span>
            </Link>

            <Link
              to="/branches"
              className="nav-item mb-2 border-start border-secondary"
              style={{ textDecoration: "none" }}
            >
              <span className="nav-link text-white">
                <GiHumanPyramid className="me-2" /> {!isCollapsed && "Branches"}
              </span>
            </Link>

            <div className="flex-grow-1"></div>
          </ul>
        </div>

        <ul className="nav flex-column p-3">
          <small className="nav ml-5 mb-0 text-secondary">Extras</small>

          <Link
            to="/scanners"
            className="nav-item mb-2 border-start border-secondary"
            style={{ textDecoration: "none" }}
          >
            <span className="nav-link text-white">
              <FaTable className="me-2" /> {!isCollapsed && "Scanners"}
            </span>
          </Link>
          <li className="nav-item mb-2">
            <span className="nav-link text-white">
              <FaMapMarkedAlt className="me-2" /> {!isCollapsed && "About"}
            </span>
          </li>
        </ul>
      </div>
    </div>
  );
}

export default SideBar;
